import React, { useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import * as resumeService from '../../services/resumeService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function DuplicateModal({ isOpen, onClose, originalTitle, resumeId }) {
	const [title, setTitle] = useState(`${originalTitle || 'Resume'} - Copy`);
	const navigate = useNavigate();

	async function handleCreate() {
		try {
			const res = await resumeService.duplicateResume(resumeId);
			toast.success('Duplicated');
			onClose?.();
			navigate(`/resumes/${res.resume._id}/edit`);
		} catch (e) {
			toast.error('Failed to duplicate');
		}
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Duplicate Resume">
			<label className="block text-sm font-medium text-gray-700 mb-1">New Title</label>
			<input className="w-full border rounded px-3 py-2" value={title} onChange={(e) => setTitle(e.target.value)} />
			<div className="mt-3 flex justify-end gap-2">
				<Button variant="ghost" onClick={onClose}>
					Cancel
				</Button>
				<Button onClick={handleCreate}>Create</Button>
			</div>
		</Modal>
	);
}


